<template>
  <div>
    <br />
    <h2 class="ViewHeading">Risk Assessment Portal</h2>
    <div>
      <b-row
        ><b-col>
          <h4>{{ this.selectedlocation }}</h4>
        </b-col></b-row
      >

      <b-row> </b-row>
    </div>
    <div v-if="this.UserAccess == 'RSA'">
      <b-card v-if="this.ReviewAssessment == 'False'">
        <b-row
          ><b-col class="text-center"
            >Review a completed Risk Assessment:</b-col
          ></b-row
        >
        <b-row
          ><b-col class="text-center"
            ><b-button
              size="sm"
              variant="info"
              v-on:click="ReviewAssessmentChoose()"
              >Select</b-button
            ></b-col
          ></b-row
        >
      </b-card>
      <div v-if="this.ReviewAssessment == 'True'">
        <RiskAssessmentReview @RevEvent="ReviewEvent"></RiskAssessmentReview>
      </div>
    </div>
    <div v-if="this.UserAccess == 'RSX'">
      <b-card>
        <div
          v-if="
            this.StartAssessment == 'False' &&
              this.CompleteAssessment == 'False'
          "
        >
          <b-card-group deck>
            <b-card>
              <b-row
                ><b-col class="text-center"
                  >Start a new Risk Assessment:</b-col
                ></b-row
              >
              <b-row
                ><b-col class="text-center"
                  ><b-button
                    size="sm"
                    variant="info"
                    v-on:click="NewAssessment()"
                    >Start</b-button
                  ></b-col
                ></b-row
              ></b-card
            >
            <b-card
              ><b-row
                ><b-col class="text-center"
                  >Upload and complete an In-Progress Risk Assessment:</b-col
                ></b-row
              >
              <b-row
                ><b-col class="text-center"
                  ><b-button
                    size="sm"
                    variant="info"
                    v-on:click="InProgressAssessment()"
                    >Complete</b-button
                  ></b-col
                ></b-row
              ></b-card
            >
          </b-card-group>
        </div>
        <div v-if="this.StartAssessment == 'True'">
          <b-card>
            <template #footer>
              <b-row
                ><b-col
                  ><b-button
                    size="sm"
                    variant="outline-info"
                    v-on:click="CancelStartAssessment()"
                    >Cancel</b-button
                  ></b-col
                ></b-row
              >
            </template>
            <br />
            <b-row
              ><b-col class="text-center"
                ><h3>
                  Risk Assessment ID: {{ this.LinkedRiskAssessment }}
                </h3></b-col
              ></b-row
            >
            <b-row
              ><b-col><br /></b-col
            ></b-row>
            <b-row
              ><b-col
                ><p class="infotext">
                  Complete all fields below and select category to enable
                  download of Risk Assessment Form and complete registration
                  process.
                </p></b-col
              ></b-row
            >
            <br />
            <b-row>
              <b-col cols="2"> Risk Assessor: </b-col>
              <b-col cols="3"
                ><b-form-input
                  type="text"
                  placeholder="Assessor"
                  v-model="AssessmentObject.Details.Assessor"
              /></b-col>
              <b-col cols="3"> Assessment Type: </b-col>
              <b-col cols="4"
                ><b-form-input
                  type="text"
                  placeholder="Assessment Type"
                  v-model="AssessmentObject.Details.ServiceNote"
              /></b-col>
            </b-row>
            <br />
            <b-row>
              <b-col cols="3">Arranged By: </b-col>
              <b-col cols="6"
                ><b-form-input
                  type="text"
                  placeholder="Arranged By"
                  v-model="AssessmentObject.Details.ArrangedBy"
              /></b-col>
            </b-row>
            <hr />
            <b-row>
              <b-col cols="2"> Date: </b-col>
              <b-col cols="4"
                ><b-form-datepicker
                  v-model="AssessmentObject.Details.Date"
                  locale="en"
                  :placeholder="AssessmentObject.Details.Date"
                ></b-form-datepicker
              ></b-col>
              <b-col cols="2"> Time: </b-col>
              <b-col cols="4"
                ><b-form-timepicker
                  v-model="AssessmentObject.Details.Time"
                  locale="en"
                  :placeholder="AssessmentObject.Details.Time"
                ></b-form-timepicker
              ></b-col>
            </b-row>
            <hr />
            <b-row>
              <b-col cols="3"> Room/Area: </b-col>
              <b-col cols="6"
                ><b-form-input
                  type="text"
                  placeholder="Room/Area"
                  v-model="AssessmentObject.Details.Room"
              /></b-col>
            </b-row>
            <br />
            <b-row>
              <b-col cols="3"> Location Note: </b-col>
              <b-col cols="9"
                ><b-form-input
                  type="text"
                  placeholder="Location Note"
                  v-model="AssessmentObject.Details.LocationNote"
              /></b-col>
            </b-row>
            <hr />
            <b-row>
              <b-col cols="3"> Contact Name: </b-col>
              <b-col cols="6"
                ><b-form-input
                  type="text"
                  placeholder="Contact Name"
                  v-model="AssessmentObject.Details.ContactName"
              /></b-col>
            </b-row>
            <br />
            <b-row>
              <b-col cols="3"> Contact Email: </b-col>
              <b-col cols="6"
                ><b-form-input
                  type="text"
                  placeholder="Contact Email"
                  v-model="AssessmentObject.Details.ContactEmail"
              /></b-col>
            </b-row>
            <br />
            <b-row>
              <b-col cols="3"> Contact Note: </b-col>
              <b-col cols="9"
                ><b-form-input
                  type="text"
                  placeholder="Contact Note"
                  v-model="AssessmentObject.Details.ContactNote"
              /></b-col>
            </b-row>
            <hr />
            <b-row>
              <b-col cols="3">Risk Assessment Category:</b-col>
              <b-col cols="6"
                ><b-form-select
                  :options="this.CategoryOptions"
                  v-model="AssessmentObject.Details.Environment"
                ></b-form-select
              ></b-col>
            </b-row>
            <br />
            <div
              v-if="
                (this.AssessmentObject.Details.Assessor != null ||
                  this.AssessmentObject.Details.Assessor == '') &&
                  this.AssessmentObject.Details.Environment != null &&
                  (this.AssessmentObject.Details.Room != null ||
                    this.AssessmentObject.Details.Room == '') &&
                  (this.AssessmentObject.Details.Date != null ||
                    this.AssessmentObject.Details.Date == '') &&
                  (this.AssessmentObject.Details.Time != null ||
                    this.AssessmentObject.Details.Time == '') &&
                  (this.AssessmentObject.Details.ServiceNote != null ||
                    this.AssessmentObject.Details.ServiceNote == '') &&
                  (this.AssessmentObject.Details.ArrangedBy != null ||
                    this.AssessmentObject.Details.ArrangedBy == '') &&
                  (this.AssessmentObject.Details.ContactName != null ||
                    this.AssessmentObject.Details.ContactName == '') &&
                  (this.AssessmentObject.Details.ContactEmail != null ||
                    this.AssessmentObject.Details.ContactEmail == '')
              "
            >
              <b-row
                ><b-col class="text-center"
                  ><b-button
                    variant="outline-success"
                    v-on:click="DownloadRiskAssessment()"
                    >Download Risk Assessment Form
                    <BIconDownload></BIconDownload></b-button></b-col
              ></b-row>
            </div>
          </b-card>
        </div>
        <div v-if="this.CompleteAssessment == 'True'">
          <b-card>
            <template #footer>
              <b-row
                ><b-col
                  ><b-button
                    size="sm"
                    variant="outline-info"
                    v-on:click="CancelCompleteAssessment()"
                    >Cancel</b-button
                  ></b-col
                ></b-row
              >
            </template>
            <br />
            <b-row
              ><b-col class="text-center"
                ><h3>
                  Risk Assessment ID: {{ this.LinkedRiskAssessment }}
                </h3></b-col
              ></b-row
            >
            <b-row
              ><b-col><br /></b-col
            ></b-row>
            <br />
            <b-row>
              <b-col cols="3"> Risk Assessor: </b-col>
              <b-col cols="3">{{ AssessmentObject.Details.Assessor }}</b-col>
              <b-col cols="3"> Assessment Type: </b-col>
              <b-col cols="3">{{ AssessmentObject.Details.ServiceNote }}</b-col>
            </b-row>
            <hr />
            <b-row>
              <b-col cols="3">Commence Date: </b-col>
              <b-col cols="3">{{ AssessmentObject.Details.Date }} </b-col>
              <b-col cols="3">Commence Time: </b-col>
              <b-col cols="3">{{ AssessmentObject.Details.Time }} </b-col>
            </b-row>
            <hr />
            <b-row>
              <b-col cols="3"> Room/Area: </b-col>
              <b-col cols="6">{{ AssessmentObject.Details.Room }}</b-col>
            </b-row>
            <br />
            <b-row>
              <b-col cols="3"> Location Note: </b-col>
              <b-col cols="9">{{
                AssessmentObject.Details.LocationNote
              }}</b-col>
            </b-row>
            <hr />
            <b-row>
              <b-col cols="3"> Contact Name: </b-col>
              <b-col cols="6">{{ AssessmentObject.Details.ContactName }}</b-col>
            </b-row>
            <br />
            <b-row>
              <b-col cols="3"> Contact Email: </b-col>
              <b-col cols="6">{{
                AssessmentObject.Details.ContactEmail
              }}</b-col>
            </b-row>
            <br />
            <b-row>
              <b-col cols="3"> Contact Note: </b-col>
              <b-col cols="9">{{ AssessmentObject.Details.ContactNote }}</b-col>
            </b-row>
            <hr />
            <b-row>
              <b-col cols="3">Risk Assessment Category:</b-col>
              <b-col cols="6">{{ AssessmentObject.Details.Environment }}</b-col>
            </b-row>
            <br />
            <b-row
              ><b-col class="text-center"
                ><b-button variant="outline-info" v-on:click="UploadFile()"
                  >Upload Files <BIconUpload></BIconUpload></b-button
              ></b-col>
            </b-row>
            <br />
            <b-table
              stacked="sm"
              id="UploadsTable"
              hover
              sticky-header
              no-border-collapse
              responsive
              small
              :items="this.UploadedFiles"
              :fields="this.UploadHeaders"
              show-empty
              empty-text="There are no files currently associated with this Assessment."
            >
            </b-table>
            <br />
            <div class="text-center" v-if="this.UploadedFiles.length == 0">
              <p class="infotext">
                Additional Information fields will appear once assessment
                documents are uploaded
              </p>
            </div>

            <div v-if="this.UploadedFiles.length > 0">
              <b-row><b-col>Findings</b-col></b-row>
              <b-row
                ><b-col>
                  <b-form-textarea
                    id="textarea"
                    v-model="AssessmentObject.Findings"
                    placeholder="Enter Findings"
                    rows="3"
                    max-rows="6"
                  ></b-form-textarea></b-col
              ></b-row>
              <br />
              <b-row><b-col>Risks</b-col></b-row>
              <b-card no-body>
                <b-card-body>
                  <b-row v-if="this.NewRiskList.length > 0" class="actionrow">
                    <b-col cols="3" class="headercol">Risk Category</b-col>
                    <b-col cols="3" class="headercol">Risk Level</b-col>
                    <b-col cols="5" class="headercol">Risk Note</b-col>
                    <b-col cols="1" class="headercol"></b-col
                  ></b-row>
                  <b-row v-if="this.NewRiskList.length == 0">
                    <b-col class="text-center">No Current Risk Added</b-col>
                  </b-row>
                  <b-row
                    v-for="(NewRisk, id) in this.NewRiskList"
                    :key="id"
                    class="actionrow"
                  >
                    <b-col cols="3" class="bodycol">{{
                      NewRisk.Category
                    }}</b-col>
                    <b-col cols="3" class="bodycol">{{ NewRisk.Level }}</b-col>
                    <b-col cols="5" class="bodycol">{{ NewRisk.Note }}</b-col>
                    <b-col cols="1" class="bodycol"
                      ><b-button
                        variant="outline-danger"
                        size="sm"
                        v-on:click="removeRisk(id)"
                        ><BIconXSquare></BIconXSquare></b-button
                    ></b-col>
                  </b-row>
                  <br />
                </b-card-body>
              </b-card>
              <b-row
                ><b-col
                  ><b-button
                    variant="outline-secondary"
                    size="sm"
                    v-on:click="addRisk()"
                    ><BIconPlus></BIconPlus>Add Risk</b-button
                  ></b-col
                ></b-row
              >
              <br />
              <b-row><b-col>Recommendations</b-col></b-row>
              <b-row
                ><b-col>
                  <b-form-textarea
                    id="textarea"
                    v-model="AssessmentObject.Recommendations"
                    placeholder="Enter Recommendations"
                    rows="3"
                    max-rows="6"
                  ></b-form-textarea></b-col
              ></b-row>
              <br />
              <div
                v-if="
                  this.UploadedFiles.length > 0 &&
                    this.AssessmentObject.Findings != null &&
                    this.AssessmentObject.Recommendations != null
                "
              >
                <b-row
                  ><b-col class="text-center"
                    ><b-button
                      variant="outline-success"
                      v-on:click="CompleteRiskAssessment()"
                      >Submit & Complete</b-button
                    ></b-col
                  ></b-row
                >
              </div>
            </div>
          </b-card>
        </div>
      </b-card>
      <br />
    </div>
    <div></div>
    <b-modal
      size="lg"
      ref="RiskAssessmentPreModal"
      id="RiskAssessmentPreModal"
      title="Risk Assessment Pre Questionnaire"
      content-class="Modal"
      header-bg-variant="light"
      header-text-variant="dark"
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
    >
      <b-card>
        <b-tabs v-model="PreModalTabs">
          <b-tab title="Scheduled Appointments">
            <b-card v-if="this.ScheduledRiskAssessmentItems.length == 0">
              <p>
                There are no current Scheduled Risk Assessments for this
                location.
              </p>
              <p>
                Check box below and submit to proceed with a new Risk
                Assessment.
              </p>
            </b-card>
            <b-card v-if="this.ScheduledRiskAssessmentItems.length > 0">
              <p>
                There are Risk Assessments scheduled for this location, please
                select if you are completing one of the below:
              </p>
              <br />
              <b-table
                sticky-header
                no-border-collapse
                responsive
                :items="ScheduledRiskAssessmentItems"
                :fields="ScheduledRiskAssessmentFields"
                hover
                small
              >
                <template v-slot:cell(Selected)="{ item }">
                  <b-form-checkbox v-model="item.Selected"></b-form-checkbox>
                </template>
              </b-table>
            </b-card>
            <b-row>
              <b-col cols="8" class="text-right"
                >Proceed without Scheduled Appointment</b-col
              >
              <b-col cols="4" class="text-left"
                ><b-form-checkbox
                  v-model="NoAppointment"
                  value="true"
                  unchecked-value="false"
                ></b-form-checkbox
              ></b-col>
            </b-row>
          </b-tab>
          <b-tab title="Incomplete Registrations ">
            <b-card v-if="this.IncompleteItems.length == 0">
              <p>
                You have no incomplete registrations at this time.
              </p>
            </b-card>
            <b-card v-if="this.IncompleteItems.length > 0">
              <p>
                There are Risk Assessments that you haven't fully registered,
                please select if you are completing one of the below:
              </p>
              <br />
              <b-table
                sticky-header
                no-border-collapse
                responsive
                :items="IncompleteItems"
                :fields="IncompleteFields"
                hover
                small
              >
                <template v-slot:cell(Selected)="{ item }">
                  <b-form-checkbox v-model="item.Selected"></b-form-checkbox>
                </template>
              </b-table>
            </b-card>
          </b-tab>
        </b-tabs>
      </b-card>
      <br />
      <br />
      <b-row>
        <b-col
          ><b-button v-on:click="PreAssessmentSubmit()" variant="outline-info"
            >Submit</b-button
          ></b-col
        >
        <b-col
          ><b-button v-on:click="PreAssessmentCancel()" variant="outline-info"
            >Cancel</b-button
          ></b-col
        >
      </b-row>
      <b-row
        ><b-col><br /></b-col
      ></b-row>
      <br />
    </b-modal>
    <b-modal
      size="lg"
      ref="RiskAssessmentReviewModal"
      id="RiskAssessmentReviewModal"
      title="Risk Assessment Review"
      content-class="Modal"
      header-bg-variant="light"
      header-text-variant="dark"
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
    >
      <b-card v-if="this.ReviewRiskAssessmentItems.length == 0">
        <p>There are no current Risk Assessments for Review.</p>
      </b-card>
      <b-card v-if="this.ReviewRiskAssessmentItems.length > 0">
        <p>Please select which Risk Assessment you wish to complete below:</p>
        <br />
        <b-table
          sticky-header
          no-border-collapse
          responsive
          :items="ReviewRiskAssessmentItems"
          :fields="ReviewRiskAssessmentFields"
          hover
          small
        >
          <template v-slot:cell(Selected)="{ item }">
            <b-form-checkbox v-model="item.Selected"></b-form-checkbox>
          </template>
        </b-table>
        <br />
      </b-card>
      <b-row
        ><b-col><br /></b-col
      ></b-row>
      <b-row>
        <b-col v-if="this.ReviewRiskAssessmentItems.length > 0"
          ><b-button
            v-on:click="ReviewAssessmentSubmit()"
            variant="outline-info"
            >Submit</b-button
          ></b-col
        >
        <b-col
          ><b-button
            v-on:click="ReviewAssessmentCancel()"
            variant="outline-info"
            >Cancel</b-button
          ></b-col
        >
      </b-row>
      <b-row
        ><b-col><br /></b-col
      ></b-row>
      <br />
    </b-modal>
    <b-modal
      size="lg"
      ref="RiskAssessmentPostModal"
      id="RiskAssessmentPostModal"
      title="Risk Assessment Upload"
      content-class="Modal"
      header-bg-variant="light"
      header-text-variant="dark"
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
    >
      <b-card>
        <b-tabs v-model="PostModalTabs">
          <b-tab title="Assigned To You"
            ><b-card
              v-if="this.AssignedInProgressRiskAssessmentItems.length == 0"
            >
              <p>
                There are no current In Progress Risk Assessments assigned to
                you.
              </p>
            </b-card>
            <b-card
              v-if="this.AssignedInProgressRiskAssessmentItems.length > 0"
            >
              <p>
                Please select which Risk Assessment you wish to complete below:
              </p>
              <br />
              <b-table
                sticky-header
                no-border-collapse
                responsive
                :items="AssignedInProgressRiskAssessmentItems"
                :fields="InProgressRiskAssessmentFields"
                hover
                small
              >
                <template v-slot:cell(Selected)="{ item }">
                  <b-form-checkbox v-model="item.Selected"></b-form-checkbox>
                </template>
              </b-table>
            </b-card>
          </b-tab>
          <b-tab title="By Location">
            <b-card
              v-if="this.LocationInProgressRiskAssessmentItems.length == 0"
            >
              <p>
                There are no current In Progress Risk Assessments for this
                location.
              </p>
            </b-card>
            <b-card
              v-if="this.LocationInProgressRiskAssessmentItems.length > 0"
            >
              <p>
                Please select which Risk Assessment you wish to complete below:
              </p>
              <br />
              <b-table
                sticky-header
                no-border-collapse
                responsive
                :items="LocationInProgressRiskAssessmentItems"
                :fields="InProgressRiskAssessmentFields"
                hover
                small
              >
                <template v-slot:cell(Selected)="{ item }">
                  <b-form-checkbox v-model="item.Selected"></b-form-checkbox>
                </template>
              </b-table>
            </b-card>
          </b-tab>
        </b-tabs>
      </b-card>
      <br />
      <b-row
        ><b-col><br /></b-col
      ></b-row>
      <b-row>
        <b-col
          v-if="
            this.AssignedInProgressRiskAssessmentItems.length > 0 ||
              this.LocationInProgressRiskAssessmentItems.length > 0
          "
          ><b-button
            v-on:click="CompleteAssessmentSubmit()"
            variant="outline-info"
            >Submit</b-button
          ></b-col
        >
        <b-col
          ><b-button
            v-on:click="CompleteAssessmentCancel()"
            variant="outline-info"
            >Cancel</b-button
          ></b-col
        >
      </b-row>
      <b-row
        ><b-col><br /></b-col
      ></b-row>
      <br />
    </b-modal>
    <b-modal
      ref="DownloadedModal"
      id="DownloadedModal"
      title="Risk Assessment Downloaded"
      content-class="Modal"
      header-bg-variant="light"
      header-text-variant="dark"
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
      hide-header
    >
      <b-card>
        <b-row><b-col>Risk Assessment form downloaded</b-col></b-row>
        <b-row
          ><b-col>This can now be saved and completed offline.</b-col>
        </b-row>
        <br />
        <b-row
          ><b-col
            ><b-button variant="outline-info" v-on:click="DownloadOK()"
              >OK</b-button
            ></b-col
          ></b-row
        >
      </b-card>
    </b-modal>
    <b-modal
      ref="AddRiskModal"
      id="AddRiskModal"
      title="Add New Risk"
      content-class="Modal"
      header-bg-variant="light"
      header-text-variant="dark"
      hide-footer
    >
      <b-card>
        <b-row>
          <b-col cols="4" class="text-left">Risk Assessment</b-col>
          <b-col cols="8">{{ NewRisk.RiskAssessment }}</b-col>
        </b-row>
        <br />
        <b-row>
          <b-col cols="4" class="text-left">Category</b-col>
          <b-col cols="8"
            ><b-form-input type="text" v-model="NewRisk.Category"
          /></b-col>
        </b-row>
        <br />
        <b-row>
          <b-col cols="4" class="text-left">Risk Level</b-col>
          <b-col cols="8">
            <b-form-select
              v-model="NewRisk.Level"
              :options="RiskLevels"
            ></b-form-select>
          </b-col>
        </b-row>
        <br />
        <b-row>
          <b-col cols="4" class="text-left">Note </b-col>
          <b-col cols="8">
            <b-form-textarea
              id="textarea"
              v-model="NewRisk.Note"
              placeholder="Enter Notes"
              rows="2"
              max-rows="4"
            ></b-form-textarea>
          </b-col>
        </b-row>
        <br />
        <br />
        <b-row
          ><b-col
            ><b-button
              size="sm"
              variant="outline-info"
              v-on:click="SubmitRiskModal()"
              >Save Risk</b-button
            ></b-col
          >
          <b-col
            ><b-button
              size="sm"
              variant="outline-info"
              v-on:click="CancelRiskModal()"
              >Cancel Risk</b-button
            ></b-col
          ></b-row
        >
      </b-card>
    </b-modal>
    <b-modal
      ref="AddFileModal"
      id="AddFileModal"
      title="Add New File"
      content-class="Modal"
      header-bg-variant="light"
      header-text-variant="dark"
      no-close-on-backdrop
      no-close-on-esc
    >
      <template #modal-footer>
        <b-button variant="secondary" size="sm" v-on:click="CancelUpload()"
          >Cancel</b-button
        >
      </template>
      <RiskUpload @fileEvent="fileUploaded"></RiskUpload>
    </b-modal>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import RiskUpload from "../views/RiskUpload.vue";
import RiskAssessmentReview from "../components/RiskAssessmentReviewAG.vue";
import { riskDirectDownloadByKey } from "@/Services/aws.js";
import {
  BIconDownload,
  BIconUpload,
  BIconXSquare,
  BIconPlus,
} from "bootstrap-vue";
export default {
  data() {
    return {
      LinkRiskLocation: "",
      selectedlocation: localStorage.getItem("CurrentLocation"),
      name: localStorage.getItem("fullname"),
      UserAccess: localStorage.getItem("accessGroup"),
      ParentCompany: localStorage.getItem("ParentCompany"),
      StartAssessment: "False",
      LinkedRiskAssessment: "",
      CompleteAssessment: "False",
      ReviewAssessment: "False",
      FormUploaded: "False",
      UploadedFiles: [],
      UploadType: null,
      PostModalTabs: 0,
      PreModalTabs: 0,
      NoAppointment: "false",
      NewRiskList: [],
      NewRisk: {
        Category: null,
        Level: null,
        Note: null,
      },
      CategoryOptions: [
        { value: null, text: "Select Category" },
        { value: "Healthcare", text: "Healthcare Environment" },
        { value: "NonHealthcare", text: "Non-Healthcare Environment" },
      ],

      AssessmentObject: {
        Details: {
          ID: null,
          Assessor: null,
          Environment: null,
          Room: null,
          Date: null,
          Time: null,
          LocationNote: null,
          ServiceNote: "Full Assessment",
          ArrangedBy: null,
          ContactName: null,
          ContactEmail: null,
          ContactNote: null,
        },
        Findings: null,
        Recommendations: null,
        Risks: null,
        Documents: null,
      },
      DetailsCompleted: "false",
      ScheduledRiskAssessmentFields: [
        { key: "Date", label: "Date" },
        { key: "Room", label: "Room Area" },
        { key: "LocationNote", label: "Location Note" },
        { key: "Selected", label: "" },
      ],
      IncompleteFields: [
        { key: "AssessmentID", label: "Assessment ID" },
        { key: "Location", label: "Location" },
        { key: "RiskAssessmentArea", label: "Area" },
        { key: "RiskAssessmentDate", label: "Date" },
        { key: "RiskAssessmentTime", label: "Time" },
        { key: "Selected", label: "" },
      ],
      ScheduledRiskAssessmentItems: [],
      IncompleteItems: [],
      ReviewRiskAssessmentItems: [],
      ChosenAppointment: "",
      RiskLevels: [
        { value: null, text: "Please select an option" },
        { value: "Insignificant", text: "Insignificant Risk" },
        { value: "Low", text: "Low Risk" },
        { value: "Medium", text: "Medium Risk" },
        { value: "High", text: "High Risk" },
        { value: "Critical", text: "Critical Risk" },
      ],
      AssignedInProgressRiskAssessmentItems: [],
      LocationInProgressRiskAssessmentItems: [],
      InProgressRiskAssessmentFields: [
        { key: "ID", label: "ID" },
        { key: "Type", label: "Type" },
        { key: "Date", label: "Date" },
        { key: "Time", label: "Time" },
        { key: "Assessor", label: "Assessor" },
        { key: "Selected", label: "" },
      ],
      ReviewRiskAssessmentFields: [
        { key: "ID", label: "ID" },
        { key: "Location", label: "Location" },
        { key: "Type", label: "Type" },
        { key: "Date", label: "Date" },
        { key: "Time", label: "Time" },
        { key: "Assessor", label: "Assessor" },
        { key: "Selected", label: "" },
      ],
      UploadHeaders: [
        { key: "AttachmentName", label: "Attachment Name" },
        {
          key: "Date",
          label: "Upload Date",
        },
        {
          key: "Time",
          label: "Upload Time",
        },
        { key: "Type" },
      ],
    };
  },

  components: {
    BIconDownload,
    BIconUpload,
    BIconXSquare,
    BIconPlus,
    RiskUpload,
    RiskAssessmentReview,
  },
  methods: {
    NewAssessment() {
      this.NoAppointment = "false";
      let IncompleteLookupURL =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let IncompleteLookupHeaders = this.$apikeyPost;
      let IncompleteLookupRequest = {
        ServiceType: "RiskAssessment",
        RequestType: "RiskAssessmentNew",
        DataDict: [
          {
            Assessor: "RiskAss External",
          },
        ],
      };
      axios
        .post(
          IncompleteLookupURL,
          IncompleteLookupRequest,
          IncompleteLookupHeaders
        )
        .then((response) => {
          let incompletearray = [];
          this.IncompleteItems = [];
          incompletearray = response.data.Values;

          for (let u = 0; u < incompletearray.length; u++) {
            this.IncompleteItems.push({
              AssessmentID: incompletearray[u][0],
              Location: incompletearray[u][1],
              RiskAssessmentArea: incompletearray[u][2],
              RiskAssessmentRoom: incompletearray[u][3],
              RiskAssessmentType: incompletearray[u][4],
              RiskAssessmentDesc: incompletearray[u][5],
              RiskAssessmentDate: incompletearray[u][6],
              RiskAssessmentTime: incompletearray[u][7],
              Selected: false,
            });
          }
        });

      let LookUpURLScheduled =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let LookUpHeadersScheduled = this.$apikeyPost;
      let LookUpRequestScheduled = {
        ServiceType: "RiskAssessment",
        RequestType: "RiskAssessmentScheduled",
        DataDict: [
          {
            Location: "Angel Guard HQ",
          },
        ],
      };
      axios
        .post(
          LookUpURLScheduled,
          LookUpRequestScheduled,
          LookUpHeadersScheduled
        )
        .then((response) => {
          let RiskAssessArray = [];
          this.ScheduledRiskAssessmentItems = [];
          RiskAssessArray = response.data.Values;

          for (let i = 0; i < RiskAssessArray.length; i++) {
            this.ScheduledRiskAssessmentItems.push({
              ID: RiskAssessArray[i][0],
              ServiceNote: RiskAssessArray[i][3],
              ArrangedBy: RiskAssessArray[i][6],
              Time: RiskAssessArray[i][8],
              ContactName: RiskAssessArray[i][9],
              ContactEmail: RiskAssessArray[i][10],
              ContactNote: RiskAssessArray[i][11],
              Date: RiskAssessArray[i][7],
              Room: RiskAssessArray[i][4],
              LocationNote: RiskAssessArray[i][5],
              Selected: false,
            });
          }
        });
      this.$refs["RiskAssessmentPreModal"].show();
    },
    InProgressAssessment() {
      let LookUpInProgress =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let LookUpHeadersInProgress = this.$apikeyPost;
      let LookUpRequestInProgress = {
        ServiceType: "RiskAssessment",
        RequestType: "RiskAssessmentInProgress",
        DataDict: [
          {
            Location: this.selectedlocation,
            Assessor: this.name,
          },
        ],
      };
      axios
        .post(
          LookUpInProgress,
          LookUpRequestInProgress,
          LookUpHeadersInProgress
        )
        .then((response) => {
          let InProgressLocationArray = [];
          let InProgressAssessorArray = [];
          (this.AssignedInProgressRiskAssessmentItems = []),
            (this.LocationInProgressRiskAssessmentItems = []),
            (InProgressLocationArray = response.data.Location),
            (InProgressAssessorArray = response.data.AssignedTo);

          for (let i = 0; i < InProgressAssessorArray.length; i++) {
            this.AssignedInProgressRiskAssessmentItems.push({
              ID: InProgressAssessorArray[i][0],
              Type: InProgressAssessorArray[i][1],
              Date: InProgressAssessorArray[i][3],
              Time: InProgressAssessorArray[i][4],
              Assessor: InProgressAssessorArray[i][5],
              Selected: false,
            });
          }

          for (let u = 0; u < InProgressLocationArray.length; u++) {
            this.LocationInProgressRiskAssessmentItems.push({
              ID: InProgressLocationArray[u][0],
              Type: InProgressLocationArray[u][1],
              Date: InProgressLocationArray[u][3],
              Time: InProgressLocationArray[u][4],
              Assessor: InProgressLocationArray[u][5],
              Selected: false,
            });
          }
        });

      this.$refs["RiskAssessmentPostModal"].show();
    },

    ReviewAssessmentChoose() {
      let LookUpVerify =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let LookUpHeadersVerify = this.$apikeyPost;
      let LookUpRequestVerify = {
        ServiceType: "RiskAssessment",
        RequestType: "RiskAssessmentVerify",
        DataDict: [
          {
            ParentCompany: this.ParentCompany,
          },
        ],
      };
      axios
        .post(LookUpVerify, LookUpRequestVerify, LookUpHeadersVerify)
        .then((response) => {
          let VerifyArray = [];
          this.ReviewRiskAssessmentItems = [];
          VerifyArray = response.data.Values;

          for (let i = 0; i < VerifyArray.length; i++) {
            this.ReviewRiskAssessmentItems.push({
              ID: VerifyArray[i][0],
              Location: VerifyArray[i][1],
              Type: VerifyArray[i][2],
              Date: VerifyArray[i][3],
              Time: VerifyArray[i][4],
              Assessor: VerifyArray[i][5],
              Selected: false,
            });
          }
        });

      this.$refs["RiskAssessmentReviewModal"].show();
    },
    PreAssessmentSubmit() {
      this.ChosenAppointment = "";
      if (this.PreModalTabs == 0) {
        if (
          this.ScheduledRiskAssessmentItems.length == 0 &&
          this.NoAppointment == "true"
        ) {
          this.ChosenAppointment = "None";
          this.AssessmentObject.Details.Assessor = this.name;
          this.AssessmentObject.Details.ArrangedBy = "Not Scheduled";
          this.AssessmentObject.Details.Date = new Date()
            .toISOString()
            .slice(0, 10);

          let RiskAssessmentURL =
            "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
            this.$environment +
            "/wms";
          let RiskAssessmentHeaders = this.$apikeyPost;
          let RiskAssessmentRequest = {
            ServiceType: "RiskAssessment",
            RequestType: "AddRiskAssessment",
            DataDict: [
              {
                Location: this.selectedlocation,
                Area: "",
                Room: "",
                Type: "Full Assessment",
                Desc: "Full Room Assessment",
                Date: this.AssessmentObject.Details.Date,
                Time: "",
                Assessor: "",
                PDFGenerated: "FALSE",
                ServiceID: "",
                AssignedTo: "",
                RiskAssessmentCategory: "",
                ContactName: "",
                ContactEmail: "",
                ContactNote: "",
              },
            ],
          };

          axios
            .post(
              RiskAssessmentURL,
              RiskAssessmentRequest,
              RiskAssessmentHeaders
            )
            .then((response) => {
              this.LinkRiskLocation = this.selectedlocation;
              this.LinkedRiskAssessment = response.data.AssessmentID;
            });

          this.$refs["RiskAssessmentPreModal"].hide();
          this.StartAssessment = "True";
        }
        if (
          this.ScheduledRiskAssessmentItems.length == 0 &&
          this.NoAppointment == "false"
        ) {
          alert("Please ensure to select an appointment option");
        } else if (this.ScheduledRiskAssessmentItems.length > 0) {
          for (let u = 0; u < this.ScheduledRiskAssessmentItems.length; u++) {
            if (this.ScheduledRiskAssessmentItems[u].Selected == true) {
              this.ChosenAppointment = this.ScheduledRiskAssessmentItems[u].ID;
              this.AssessmentObject.Details.Date = this.ScheduledRiskAssessmentItems[
                u
              ].Date;
              this.AssessmentObject.Details.Room = this.ScheduledRiskAssessmentItems[
                u
              ].Room;
              this.AssessmentObject.Details.Assessor = this.name;
              this.AssessmentObject.Details.LocationNote = this.ScheduledRiskAssessmentItems[
                u
              ].LocationNote;
              this.AssessmentObject.Details.Time = this.ScheduledRiskAssessmentItems[
                u
              ].Time;
              this.AssessmentObject.Details.ServiceNote = this.ScheduledRiskAssessmentItems[
                u
              ].ServiceNote;
              this.AssessmentObject.Details.ArrangedBy = this.ScheduledRiskAssessmentItems[
                u
              ].ArrangedBy;
              this.AssessmentObject.Details.ContactName = this.ScheduledRiskAssessmentItems[
                u
              ].ContactName;
              this.AssessmentObject.Details.ContactEmail = this.ScheduledRiskAssessmentItems[
                u
              ].ContactEmail;
              this.AssessmentObject.Details.ContactNote = this.ScheduledRiskAssessmentItems[
                u
              ].ContactNote;
              break;
            } else {
              this.ChosenAppointment = "None";
              this.AssessmentObject.Details.Assessor = this.name;
              this.AssessmentObject.Details.ArrangedBy = "Not Scheduled";
              this.AssessmentObject.Details.Date = new Date()
                .toISOString()
                .slice(0, 10);
            }
          }

          let RiskAssessmentURL =
            "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
            this.$environment +
            "/wms";
          let RiskAssessmentHeaders = this.$apikeyPost;
          let RiskAssessmentRequest = {
            ServiceType: "RiskAssessment",
            RequestType: "AddRiskAssessment",
            DataDict: [
              {
                Location: this.selectedlocation,
                Area: this.AssessmentObject.Details.Room,
                Room: this.AssessmentObject.Details.LocationNote,
                Type: "Full Assessment",
                Desc: "Full Room Assessment",
                Date: this.FormatDate(this.AssessmentObject.Details.Date),
                Time: this.AssessmentObject.Details.Time,
                Assessor: this.AssessmentObject.Details.Assessor,
                PDFGenerated: "FALSE",
                ServiceID: this.ChosenAppointment,
                AssignedTo: this.AssessmentObject.Details.Assessor,
                RiskAssessmentCategory: "",
                ContactName: this.AssessmentObject.Details.ContactName,
                ContactEmail: this.AssessmentObject.Details.ContactEmail,
                ContactNote: this.AssessmentObject.Details.ContactNote,
              },
            ],
          };

          axios
            .post(
              RiskAssessmentURL,
              RiskAssessmentRequest,
              RiskAssessmentHeaders
            )
            .then((response) => {
              this.LinkRiskLocation = this.selectedlocation;
              this.LinkedRiskAssessment = response.data.AssessmentID;
            });

          this.$refs["RiskAssessmentPreModal"].hide();
          this.StartAssessment = "True";
        }
      } else if (this.PreModalTabs == 1) {
        let selecteditem = false;
        for (let i = 0; i < this.IncompleteItems.length; i++) {
          if (this.IncompleteItems[i].Selected == true) {
            selecteditem = true;
            this.LinkedRiskAssessment = this.IncompleteItems[i].AssessmentID;
            this.AssessmentObject.Details.ID = this.IncompleteItems[
              i
            ].AssessmentID;
            this.AssessmentObject.Details.Date = this.IncompleteItems[
              i
            ].RiskAssessmentDate;
            this.AssessmentObject.Details.Room = this.IncompleteItems[
              i
            ].RiskAssessmentArea;
            this.AssessmentObject.Details.Assessor = this.name;
            this.AssessmentObject.Details.LocationNote = this.IncompleteItems[
              i
            ].RiskAssessmentRoom;
            this.AssessmentObject.Details.Time = this.IncompleteItems[
              i
            ].RiskAssessmentTime;
            this.AssessmentObject.Details.ServiceNote = "Full Assessment";
            this.AssessmentObject.Details.ArrangedBy = "";
            this.AssessmentObject.Details.ContactName = "";
            this.AssessmentObject.Details.ContactEmail = "";
            this.AssessmentObject.Details.ContactNote = "";

            break;
          } else {
            continue;
          }
        }
        if (selecteditem == false) {
          alert(
            "No selection made, please select item to continue or press cancel to close"
          );
        } else {
          this.$refs["RiskAssessmentPreModal"].hide();
          this.StartAssessment = "True";
        }
      }
    },

    FormatDate(date) {
      if (date.includes("-")) {
        return date;
      } else {
        let dt1 = parseInt(date.substring(0, 2));
        let mon1 = parseInt(date.substring(3, 5));
        let yr1 = parseInt(date.substring(6, 10));
        let dbformatdate = yr1 + "-" + mon1 + "-" + dt1;
        return dbformatdate;
      }
    },

    PreAssessmentCancel() {
      this.PreModalTabs = 0;
      this.$refs["RiskAssessmentPreModal"].hide();
      this.StartAssessment = "False";
    },

    CompleteAssessmentSubmit() {
      let RiskIDForLookup = "";
      if (this.PostModalTabs == 0) {
        for (
          let u = 0;
          u < this.AssignedInProgressRiskAssessmentItems.length;
          u++
        ) {
          if (this.AssignedInProgressRiskAssessmentItems[u].Selected == true) {
            RiskIDForLookup = this.AssignedInProgressRiskAssessmentItems[u].ID;
            this.CompleteAssessment = "True";
            break;
          } else {
            continue;
          }
        }
        if (this.CompleteAssessment == "True") {
          this.$refs["RiskAssessmentPostModal"].hide();
          let DetailsLookupURL =
            "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
            this.$environment +
            "/wms";
          let DetailsLookupHeaders = this.$apikeyPost;
          let DetailsLookupRequest = {
            ServiceType: "RiskAssessment",
            RequestType: "RiskAssessmentDetails",
            DataDict: [
              {
                AssessmentID: RiskIDForLookup,
              },
            ],
          };
          axios
            .post(DetailsLookupURL, DetailsLookupRequest, DetailsLookupHeaders)
            .then((response) => {
              let detailsarray = [];
              detailsarray = response.data.Values;
              this.LinkRiskLocation = detailsarray[1];
              this.LinkedRiskAssessment = detailsarray[0];
              this.AssessmentObject.Details.ID = detailsarray[0];
              this.AssessmentObject.Details.Assessor = detailsarray[8];
              this.AssessmentObject.Details.Environment = detailsarray[5];
              this.AssessmentObject.Details.Room = detailsarray[2];
              this.AssessmentObject.Details.Date = detailsarray[6];
              this.AssessmentObject.Details.Time = detailsarray[7];
              this.AssessmentObject.Details.LocationNote = detailsarray[3];
              this.AssessmentObject.Details.ServiceNote = detailsarray[4];
              this.AssessmentObject.Details.ContactName = detailsarray[9];
              this.AssessmentObject.Details.ContactEmail = detailsarray[10];
              this.AssessmentObject.Details.ContactNote = detailsarray[11];
            });

          this.UploadedFiles = [];
          let FilesLookupURL =
            "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
            this.$environment +
            "/wms";
          let FilesLookupHeaders = this.$apikeyPost;
          let FilesLookupRequest = {
            ServiceType: "RiskAssessment",
            RequestType: "LoadRiskAssessmentAttachments",
            DataDict: [
              {
                AssessmentID: RiskIDForLookup,
              },
            ],
          };
          axios
            .post(FilesLookupURL, FilesLookupRequest, FilesLookupHeaders)
            .then((response) => {
              let Uploadedarray = [];
              Uploadedarray = response.data.Values;

              for (let i = 0; i < Uploadedarray.length; i++) {
                this.UploadedFiles.push({
                  AttachmentName: Uploadedarray[i][2],
                  Date: Uploadedarray[i][0],
                  Time: Uploadedarray[i][1],
                  Type: Uploadedarray[i][4],
                });
              }
            });
        } else {
          alert("No Risk Assessment Chosen");
          this.$refs["RiskAssessmentPostModal"].hide();
          this.PostModalTabs = 0;
        }
      } else if (this.PostModalTabs == 1) {
        for (
          let u = 0;
          u < this.LocationInProgressRiskAssessmentItems.length;
          u++
        ) {
          if (this.LocationInProgressRiskAssessmentItems[u].Selected == true) {
            RiskIDForLookup = this.LocationInProgressRiskAssessmentItems[u].ID;
            this.CompleteAssessment = "True";
            break;
          } else {
            continue;
          }
        }
        if (this.CompleteAssessment == "True") {
          this.$refs["RiskAssessmentPostModal"].hide();
          let DetailsLookupURL =
            "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
            this.$environment +
            "/wms";
          let DetailsLookupHeaders = this.$apikeyPost;
          let DetailsLookupRequest = {
            ServiceType: "RiskAssessment",
            RequestType: "RiskAssessmentDetails",
            DataDict: [
              {
                AssessmentID: RiskIDForLookup,
              },
            ],
          };
          axios
            .post(DetailsLookupURL, DetailsLookupRequest, DetailsLookupHeaders)
            .then((response) => {
              let detailsarray = [];
              detailsarray = response.data.Values;
              this.LinkedRiskAssessment = detailsarray[0];
              this.AssessmentObject.Details.ID = detailsarray[0];
              this.AssessmentObject.Details.Assessor = detailsarray[8];
              this.AssessmentObject.Details.Environment = detailsarray[5];
              this.AssessmentObject.Details.Room = detailsarray[2];
              this.AssessmentObject.Details.Date = detailsarray[6];
              this.AssessmentObject.Details.Time = detailsarray[7];
              this.AssessmentObject.Details.LocationNote = detailsarray[3];
              this.AssessmentObject.Details.ServiceNote = detailsarray[4];
              this.AssessmentObject.Details.ContactName = detailsarray[9];
              this.AssessmentObject.Details.ContactEmail = detailsarray[10];
              this.AssessmentObject.Details.ContactNote = detailsarray[11];
            });

          this.UploadedFiles = [];
          let FilesLookupURL =
            "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
            this.$environment +
            "/wms";
          let FilesLookupHeaders = this.$apikeyPost;
          let FilesLookupRequest = {
            ServiceType: "RiskAssessment",
            RequestType: "LoadRiskAssessmentAttachments",
            DataDict: [
              {
                AssessmentID: RiskIDForLookup,
              },
            ],
          };
          axios
            .post(FilesLookupURL, FilesLookupRequest, FilesLookupHeaders)
            .then((response) => {
              let Uploadedarray = [];
              Uploadedarray = response.data.Values;

              for (let i = 0; i < Uploadedarray.length; i++) {
                this.UploadedFiles.push({
                  AttachmentName: Uploadedarray[i][2],
                  Date: Uploadedarray[i][0],
                  Time: Uploadedarray[i][1],
                  Type: Uploadedarray[i][4],
                });
              }
            });
        } else {
          alert("No Risk Assessment Chosen");
          this.$refs["RiskAssessmentPostModal"].hide();
          this.PostModalTabs = 0;
        }
      }
    },
    CompleteAssessmentCancel() {
      this.InProgressRiskAssessmentItems = [];
      this.PostModalTabs = 0;
      this.$refs["RiskAssessmentPostModal"].hide();
    },
    CancelStartAssessment() {
      this.StartAssessment = "False";
      this.AssessmentObject = {
        Details: {
          ID: null,
          Assessor: null,
          Environment: null,
          Room: null,
          Date: null,
          Time: null,
          LocationNote: null,
          ServiceNote: "Full Assessment",
          ArrangedBy: null,
          ContactName: null,
          ContactEmail: null,
          ContactNote: null,
        },
        Findings: null,
        Recommendations: null,
        Risks: null,
        Documents: null,
      };
    },
    CancelCompleteAssessment() {
      (this.CompleteAssessment = "False"),
        (this.FormUploaded = "False"),
        (this.NewRiskList = []),
        (this.UploadedFiles = []),
        (this.AssessmentObject = {
          Details: {
            ID: null,
            Assessor: null,
            Environment: null,
            Room: null,
            Date: null,
            Time: null,
            LocationNote: null,
            ServiceNote: "Full Assessment",
            ArrangedBy: null,
            ContactName: null,
            ContactEmail: null,
            ContactNote: null,
          },
          Findings: null,
          Recommendations: null,
          Risks: null,
          Documents: null,
        });
    },
    async DownloadRiskAssessment() {
      let RiskAssessmentUpdateURL =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let RiskAssessmentUpdateHeaders = this.$apikeyPost;
      let RiskAssessmentUpdateRequest = {
        ServiceType: "RiskAssessment",
        RequestType: "UpdateRiskAssessment",
        DataDict: [
          {
            RiskAssessmentArea: this.AssessmentObject.Details.Room,
            RiskAssessmentRoom: this.AssessmentObject.Details.LocationNote,
            RiskAssessmentStatus: "In Progress",
            RiskAssessmentCategory: this.AssessmentObject.Details.Environment,
            PDFGenerated: "TRUE",
            RiskAssessmentDate: this.FormatDate(
              this.AssessmentObject.Details.Date
            ),
            RiskAssessmentTime: this.AssessmentObject.Details.Time,
            AssessmentID: this.LinkedRiskAssessment,
            ContactName: this.AssessmentObject.Details.ContactName,
            ContactEmail: this.AssessmentObject.Details.ContactEmail,
            ContactNote: this.AssessmentObject.Details.ContactNote,
            ReviewedBy: "",
          },
        ],
      };
      axios
        .post(
          RiskAssessmentUpdateURL,
          RiskAssessmentUpdateRequest,
          RiskAssessmentUpdateHeaders
        )
        .then((response) => {
          response;
        });

      let filekey = "";
      let filename = "";
      this.$refs["DownloadedModal"].show();
      if (this.AssessmentObject.Details.Environment == "Healthcare") {
        filekey = "Templates/RiskAssessmentHealthcareTemplate.pdf";
        filename =
          "HealthcareRiskAssessment" + this.LinkedRiskAssessment + ".pdf";
      } else if (this.AssessmentObject.Details.Environment == "NonHealthcare") {
        filekey = "Templates/RiskAssessmentNonHealthcareTemplate.pdf";
        filename =
          "NonHealthcareRiskAssessment" + this.LinkedRiskAssessment + ".pdf";
      }

      let attachment = filekey;
      const res = await riskDirectDownloadByKey(attachment);
      axios({
        url: res, //your url
        method: "GET",
        responseType: "blob", // important
      }).then((response) => {
        // create file link in browser's memory
        const href = URL.createObjectURL(response.data);

        // create "a" HTML element with href to file & click
        const link = document.createElement("a");
        link.href = href;
        link.setAttribute("download", filename); //or any other extension
        document.body.appendChild(link);
        link.click();

        // clean up "a" element & remove ObjectURL
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
      });

      this.refreshTable();
    },

    refreshTable() {
      this.UploadedFiles = [];
      let FilesLookupURL =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let FilesLookupHeaders = this.$apikeyPost;
      let FilesLookupRequest = {
        ServiceType: "RiskAssessment",
        RequestType: "LoadRiskAssessmentAttachments",
        DataDict: [
          {
            AssessmentID: this.LinkedRiskAssessment,
          },
        ],
      };
      axios
        .post(FilesLookupURL, FilesLookupRequest, FilesLookupHeaders)
        .then((response) => {
          let Uploadedarray = [];
          Uploadedarray = response.data.Values;

          for (let i = 0; i < Uploadedarray.length; i++) {
            this.UploadedFiles.push({
              AttachmentName: Uploadedarray[i][2],
              Date: Uploadedarray[i][0],
              Time: Uploadedarray[i][1],
              Type: Uploadedarray[i][4],
            });
          }
        });
    },
    DownloadOK() {
      this.$refs["DownloadedModal"].hide();
      (this.StartAssessment = "False"),
        (this.AssessmentObject = {
          Details: {
            ID: null,
            Assessor: null,
            Environment: null,
            Room: null,
            Date: null,
            Time: null,
            LocationNote: null,
            ServiceNote: "Full Assessment",
            ArrangedBy: null,
            ContactName: null,
            ContactEmail: null,
            ContactNote: null,
          },
          Findings: null,
          Recommendations: null,
          Risks: null,
          Documents: null,
        });
    },

    UploadFile(Type) {
      Vue.prototype.$LinkedRisk = this.LinkedRiskAssessment;
      Vue.prototype.$LinkedRiskLocation = this.LinkRiskLocation;

      this.$refs["AddFileModal"].show();
      if (Type == "RiskForm") {
        this.FormUploaded = "True";
      } else {
        this.FormUploaded = "False";
      }
    },
    removeRisk(item) {
      this.NewRiskList.splice(item, 1);
      alert("Action has been removed from list");
    },
    addRisk() {
      (this.NewRisk = {
        Category: null,
        Level: null,
        Note: null,
      }),
        this.$refs["AddRiskModal"].show();
    },
    SubmitRiskModal() {
      if (
        this.NewRisk.Category == null ||
        this.NewRisk.Category == "" ||
        this.NewRisk.Level == null ||
        this.NewRisk.Note == null ||
        this.NewRisk.Note == ""
      ) {
        alert("Please ensure all fields are completed");
      } else {
        this.NewRiskList.push(this.NewRisk);

        alert("Risk Added to List");
        this.$refs["AddRiskModal"].hide();
        this.NewRisk = {
          Category: null,
          Level: null,
          Note: null,
        };
      }
    },
    CancelRiskModal() {
      this.$refs["AddRiskModal"].hide();
    },
    ReviewAssessmentSubmit() {
      let blanksubmit = true;
      let selectedreview = "";
      let selectedreviewlocation = "";

      for (let i = 0; i < this.ReviewRiskAssessmentItems.length; i++) {
        if (this.ReviewRiskAssessmentItems[i].Selected == true) {
          blanksubmit = false;
          selectedreview = this.ReviewRiskAssessmentItems[i].ID;
          selectedreviewlocation = this.ReviewRiskAssessmentItems[i].Location;
          break;
        } else {
          continue;
        }
      }

      if (blanksubmit == true) {
        alert("Please select a risk assessment to continue");
      } else {
        Vue.prototype.$LinkedRisk = selectedreview;
        Vue.prototype.$LinkedRiskLocation = selectedreviewlocation;
        this.ReviewAssessment = "True";
        this.$refs["RiskAssessmentReviewModal"].hide();
      }
    },
    ReviewAssessmentCancel() {
      this.$refs["RiskAssessmentReviewModal"].hide();
    },
    ReviewEvent() {
      this.ReviewAssessment = "False";
    },
    CancelUpload() {
      this.$refs["AddFileModal"].hide();
    },
    fileUploaded() {
      this.$refs["AddFileModal"].hide();
      this.refreshTable();
    },
    CompleteRiskAssessment() {
      let assessmentfindings = "";
      let assessmentrecommendations = "";
      let assessmentrisks = [];

      assessmentfindings = this.AssessmentObject.Findings;
      assessmentrecommendations = this.AssessmentObject.Recommendations;
      assessmentrisks = this.NewRiskList;

      let CompleteAssessmentURL =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let CompleteAssessmentHeaders = this.$apikeyPost;
      let CompleteAssessmentRequest = {
        ServiceType: "RiskAssessment",
        RequestType: "AddRiskAssessmentOutcome",
        DataDict: [
          {
            AssessmentID: this.LinkedRiskAssessment,
            Findings: assessmentfindings,
            Recommendations: assessmentrecommendations,
            RiskList: assessmentrisks,
          },
        ],
      };

      axios
        .post(
          CompleteAssessmentURL,
          CompleteAssessmentRequest,
          CompleteAssessmentHeaders
        )
        .then((response) => {
          response;
          alert(
            "Documents uploaded successfully, Risk Assessment now completed"
          );
          this.CompleteAssessment = "False";
        });
    },
  },
};
</script>
<style scoped>
p.infotext {
  font-size: medium;
  color: cadetblue;
}

.actionrow {
  margin-left: auto;
  margin-right: auto;
}

.headercol {
  border-bottom: solid 2px lightgrey;
  font-weight: bold;
  margin: 0;
  padding: 5px;
}
.bodycol {
  padding: 5px;
}
</style>
